<template>
    <div>
        <!-- Alterar Prazo de Entrega -->
        <div class="modal fade" id="alterarPrazoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Data de Entrega</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="mb-3">
                            <az-input
                                type="date"
                                icon="fas fa-calendar fa-fw"
                                label="Nova Data de Entrega"
                                required
                                :validate="validate"
                                v-model="nova_data" />
                        </div>

                        <table class="table">
                            <tr v-for="(item, iix) in lista_agrupada" :key="iix">
                                <td>
                                    <a href="#" class="card-link text-primary">
                                        {{ iix == 'Sem data' ? iix : $util.getFormatDate(iix) }}
                                    </a>
                                </td>
                                <td>
                                    {{ item.length }} procedimento(s)
                                </td>
                            </tr>
                        </table>

                        <table class="table table-hover table-sm">
                            <thead>
                                <tr>
                                    <th width="1%">
                                        <a href="#" class="card-link text-primary" @click.prevent="toggle_selec_all()">
                                            Todos
                                        </a>
                                    </th>
                                    <th>Id</th>
                                    <th>Data</th>
                                    <th>Paciente</th>
                                    <th>Procedimento</th>
                                    <th>Prazo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, iix) in lista" :key="iix">
                                    <td>
                                        <input type="checkbox" v-model="item.selecionado" />
                                    </td>
                                    <td>#{{ item.atendimento_procedimento.id_atendimento }}</td>
                                    <td>{{ $util.getFormatDate(item.atendimento_procedimento.atendimento.dt_inicio) }}</td>
                                    <td>{{ item.atendimento_procedimento.atendimento.paciente.st_nome }}</td>
                                    <td>{{ item.atendimento_procedimento.procedimento.search }}</td>
                                    <td>
                                        <span v-if="item.atendimento_procedimento.dt_entrega">
                                            {{ $util.getFormatDate(item.atendimento_procedimento.dt_entrega) }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <pre v-if="false">{{ lista }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            lista: [], 
            nova_data: "", 
            validate: false, 
        }
    },

    components: { 
        AzSubmit, 
        AzInput
    },

    computed: { 
        lista_agrupada: function () { 
            if ( !this.lista ) { 
                return [];
            }

            return _.groupBy(
                this.lista.filter(item => item.selecionado), 
                item => item.atendimento_procedimento.dt_entrega ? item.atendimento_procedimento.dt_entrega.slice(0, 10) : 'Sem data'
            );
        }
    },

    methods: { 
        toggle_selec_all () { 
            let selec = this.lista.find(item => !item.selecionado) ? true : false;

            this.lista.forEach(item => { 
                item.selecionado = selec; 
            });
        },

        abrir (lista) { 
            this.nova_data = "";
            this.validate = false; 
            
            let lista_selec = _.cloneDeep(lista);

            this.lista = lista_selec.map(item => {
                item.selecionado = true;
                return item;
            });

            $('#alterarPrazoModal').modal('show');
        }, 
        
        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'alterar_data_entrega', 
                dados: { 
                    lista: this.lista.filter(item => item.selecionado).map(item => item.atendimento_procedimento.id_atendimento_procedimento), 
                    nova_data: this.nova_data, 
                },
                callback: () => { 
                    $('#alterarPrazoModal').modal('hide');
                    this.$emit('refresh');
                }
            });

        }

    }

}
</script>
